import {
  AuditOutlined,
  TagsOutlined,
  ContainerOutlined,
  TeamOutlined,
  ApiOutlined,
  PartitionOutlined,
  ControlOutlined,
  EnvironmentOutlined,
  CloudUploadOutlined,
  CloudSyncOutlined,
  ProfileOutlined,
  PicRightOutlined,
  DashboardOutlined,
  CloudServerOutlined,
  ProjectOutlined,
  LoginOutlined,
  FileOutlined,
  MailOutlined,
  FieldTimeOutlined,
  SendOutlined,
  BellOutlined,
  FileAddTwoTone,
  EditTwoTone,
  GroupOutlined,
  FileProtectOutlined,
  FolderOpenOutlined,
  BuildOutlined,
  ContactsOutlined,
  BorderlessTableOutlined,
  ApartmentOutlined,
  InsertRowAboveOutlined,
} from "@ant-design/icons";
import store from "../../store/store";
import { useSelector } from "react-redux";
import {
  findBetaIndex,
  findSettingIndex,
  getAtleastOneBlue,
  getMainMenuName,
  getSettingViewStatus,
  getSubMenuName,
  getViewStatus,
} from "./ViewUpdateIndex";
import Notification from "../../assets/icons/org_notification_white.svg";
import Structure from "../../assets/icons/structre.svg";
import {
  accessImpersontate,
  env,
  LMS_REDIRECT_NOTIFICATION,
  LMS_REDIRECT_STRUCTURE,
  REDIRECT_DASHBOARD_TRAINERY_LEARN,
  REDIRECT_PROFILE,
} from "../../config";
import {
  getAtleastOneBlue1,
  getAtleastOneBlue2,
  getMainMenuName1,
  getMainMenuName2,
  getSubMenuName1,
  getViewStatus1,
  getViewStatus2,
  getSubMenuName2,
} from "./ViewUpdateIndexTnAdmin";
const unsubscribe = store.subscribe(() => {});
unsubscribe();

export const ClientMenu = () => {
  const userInfo = useSelector((state) => state.user);

  const ClientMenu = [
    {
      path: "/admin-manager/clients",
      name: getMainMenuName1(userInfo, 0),
    },
    getAtleastOneBlue1(userInfo, 1) && {
      path: "/admin-manager/modules",
      name: getMainMenuName1(userInfo, 1),
    },
    getAtleastOneBlue1(userInfo, 2) && {
      path: "/admin-manager/setting-naics",
      name: getMainMenuName1(userInfo, 2),
    },
    getAtleastOneBlue1(userInfo, 3) && {
      //fdfdi
      path: "/admin-manager/customers",
      name: getMainMenuName1(userInfo, 3),
    },
  ];
  const filteredDatasend = ClientMenu.filter((item) => item !== false);

  return filteredDatasend;
};

export const SettingsMenu = () => {
  const userInfo = useSelector((state) => state.user);

  const SettingsMenu = [
    {
      path: "/access-manager/admins",
      name: getMainMenuName2(userInfo, 0),
    },
    getAtleastOneBlue2(userInfo, 1) && {
      path: "/access-manager/roles",
      name: getMainMenuName2(userInfo, 1),
    },
    getAtleastOneBlue2(userInfo, 2) && {
      path: "/access-manager/access-rename",
      name: getMainMenuName2(userInfo, 2),
    },
    getAtleastOneBlue2(userInfo, 3) && {
      path: "/access-manager/notifications/",
      name: getMainMenuName2(userInfo, 3),
    },
  ];
  const filteredDatasend = SettingsMenu.filter((item) => item !== false);

  return filteredDatasend;
};

/***************************------Blue-Bar menus-------************************************* */

export const SecondaryNavClient = () => {
  const userInfo = useSelector((state) => state.user);

  const datasend = [
    // New bluebar menu item for dashboard
    // getViewStatus1(userInfo, 0, 0) && {
    //   path : '/admin-manager/clients/dashboard',
    //   name : getSubMenuName1(userInfo, 0 ,0),
    //   icon : <ProjectOutlined />,
    // },
    getViewStatus1(userInfo, 0, 0) && {
      path: "/admin-manager/clients/profile",
      name: getSubMenuName1(userInfo, 0, 0),
      icon: <AuditOutlined />,
    },
    // end
    getViewStatus1(userInfo, 0, 1) && {
      path: "/admin-manager/clients/sub",
      name: getSubMenuName1(userInfo, 0, 1),
      icon: <TagsOutlined />,
    },
    getViewStatus1(userInfo, 0, 2) && {
      path: "/admin-manager/clients/relationships",
      name: getSubMenuName1(userInfo, 0, 2),
      icon: <ApiOutlined />,
    },
    getViewStatus1(userInfo, 0, 3) && {
      path: "/admin-manager/clients/login-settings",
      name: getSubMenuName1(userInfo, 0, 3),
      icon: <CloudSyncOutlined />,
    },
    // New bluebar menu for API section
    getViewStatus1(userInfo, 0, 4) && {
      path: "/admin-manager/clients/api",
      name: getSubMenuName1(userInfo, 0, 4),
      icon: <CloudServerOutlined />,
    },

    // End
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};
export const SecondaryNavCustomer = () => {
  const userInfo = useSelector((state) => state.user);

  const datasend = [
    {
      path: "/admin-manager/customers/profile",
      name: getSubMenuName1(userInfo, 3, 0),
      icon: <AuditOutlined />,
    },
    getViewStatus1(userInfo, 3, 1) && {
      path: "/admin-manager/customers/sub",
      name: getSubMenuName1(userInfo, 3, 1),
      icon: <TagsOutlined />,
    },
    getViewStatus1(userInfo, 3, 2) && {
      path: "/admin-manager/customers/relationships",
      name: getSubMenuName1(userInfo, 3, 2),
      icon: <ApiOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};
export const SecondaryNavModule = () => {
  const userInfo = useSelector((state) => state.user);

  const datasend = [
    {
      path: "/admin-manager/modules/details",
      name: getSubMenuName1(userInfo, 1, 0),
      icon: <ContainerOutlined />,
    },
    getViewStatus1(userInfo, 0, 1) && {
      path: "/admin-manager/modules/access",
      name: getSubMenuName1(userInfo, 1, 1),
      icon: <ControlOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};

export const MainAccessEdit = [
  {
    path: "/access-manager/access-rename/edit-org",
    name: "Organization",
    icon: <ProfileOutlined />,
  },
  {
    path: "/access-manager/access-rename/edit-user",
    name: "Employees",
    icon: <TeamOutlined />,
  },
];
export const SecondaryNavTNCommunications = () => {
  const userInfo = useSelector((state) => state.user);
  const datasend = [
    getViewStatus2(userInfo, 3, 0) && {
      path: "/access-manager/notifications/view-notifications/",
      name: getSubMenuName2(userInfo, 3, 0),
      icon: <BellOutlined />,
    },
    getViewStatus2(userInfo, 3, 1) && {
      path: "/access-manager/notifications/custom-notifications/",
      name: getSubMenuName2(userInfo, 3, 1),
      icon: <MailOutlined />,
    },
  ];
  const filteredDatasend = datasend?.filter((item) => item !== false);
  return filteredDatasend;
};

export const SecondaryNavDocustore = () => {
  // const userInfo = useSelector((state) => state.user);
  const datasend = [
    // getViewStatus(userInfo, 4, 0) && {
    //   path: "/ca-admin/docustor/employees",
    //   name: getSubMenuName(userInfo, 4, 0),
    //   icon: <TeamOutlined />,
    // },
    // getViewStatus(userInfo, 4, 1) && {
    //   path: "/ca-admin/docustor/organization",
    //   name: getSubMenuName(userInfo, 4, 1),
    //   icon: <ApartmentOutlined />,
    // },
    {
      path: "/ca-admin/organization/docustor/employees",
      name: "Employees",
      icon: <TeamOutlined />,
    },
    {
      path: "/ca-admin/organization/docustor/organization",
      name: "Organization",
      icon: <ApartmentOutlined />,
    },
  ];
  const filteredDatasend = datasend?.filter((item) => item !== false);
  return filteredDatasend;
};
export const ThirdNavSub = (id, p_id, notActive = false) => {
  const datasend = [
    true && {
      path: `/admin-manager/clients/sub/${id}`,
      name: "Subscription Summary",
      icon: <TagsOutlined />,
      not_active: notActive,
    },
    // Purchase Summary Tab - Commented out
    // true && {
    //   path: `/admin-manager/clients/sub/${id}/lms/${p_id}`,
    //   name: "Purchase Summary",
    //   icon: <FolderOpenOutlined />,
    // },
  ];
  const filteredDatasend = datasend?.filter((item) => item !== false);
  return filteredDatasend;
};
//****************************************ca admin routes*********************************** */

export const CaAdminMenu = () => {
  const userInfo = useSelector((state) => state.user);

  const CadminMenu = [
    {
      path: "/ca-admin/organization/profile",
      name: getMainMenuName(userInfo, 0),
    },
    getAtleastOneBlue(userInfo, 1) && {
      path: "/ca-admin/organization/settings",
      name: getMainMenuName(userInfo, 1),
    },
    getAtleastOneBlue(userInfo, 2) && {
      path: "/ca-admin/organization/audit-trail",
      name: getMainMenuName(userInfo, 2),
    },
    getAtleastOneBlue(userInfo, 3) && {
      path: "/ca-admin/organization/communications",
      name: getMainMenuName(userInfo, 3),
    },
    // {
    //   path: "/ca-admin/organization/calender",
    //   name: "CALENDER",
    // },
    // getAtleastOneBlue(userInfo, 4) && {
    //   path: "/ca-admin/docustor/employees",
    //   name: getMainMenuName(userInfo, 4),
    // },
    // {
    //   path: "/ca-admin/organization/docustor/employees",
    //   name: "Docustor",
    // },
  ];

  // Use userInfo data to modify CadminMenu if needed
  //console.log(userInfo);
  const filteredDatasend = CadminMenu.filter((item) => item !== false);

  return filteredDatasend;
};

export const CaAdminSettingsMenu = () => {
  const userInfo = useSelector((state) => state.user);

  const settingsIndex = findSettingIndex(userInfo?.data?.access);
  const settingsMenuIndex = userInfo?.data?.access?.[
    settingsIndex
  ]?.side_menu?.findIndex((menu) => menu?.key_name === "Settings");
  const topMenus =
    userInfo?.data?.access?.[settingsIndex]?.side_menu?.[settingsMenuIndex]
      ?.top_menu || [];

  const dynamicSettingsItems = topMenus
    .map((menuItem, index) => {
      const hasViewAccess = getSettingViewStatus(
        userInfo,
        index,
        settingsMenuIndex,
        0
      );
      if (!hasViewAccess) return null;

      const isRedirect = menuItem.app !== "CENTRAL";
      let path = menuItem.url;

      if (!isRedirect && path?.startsWith("https://testapps.trainery.one/")) {
        path = path.replace("https://testapps.trainery.one", "");
      }

      return {
        path,
        name: menuItem.name,
        redirect: isRedirect,
      };
    })
    .filter(Boolean);
  // // Append your new item at the last index
  // const finalSettingsItems = [
  //   ...dynamicSettingsItems,
  //   {
  //     path: "/settings/work-roles",
  //     name: "Work Roles",
  //     redirect: false,
  //   },
  // ];

  // console.log(finalSettingsItems, "finalSettingsItems");
  // return finalSettingsItems;
  // //
  console.log(dynamicSettingsItems, "dynamicSettingsItems");
  return dynamicSettingsItems;
};
export const CaAdminLearningMenu = () => {
  const userInfo = useSelector((state) => state.user);
  const ImpersonateAccess = accessImpersontate(userInfo?.data?.impersonate_acc);
  const settingsIndex = ImpersonateAccess
    ? findBetaIndex(userInfo?.data?.access)
    : findSettingIndex(userInfo?.data?.access);
  const settingsMenuIndex = userInfo?.data?.access?.[
    settingsIndex
  ]?.side_menu?.findIndex((menu) => menu?.key_name === "Learning Journey");
  const topMenus =
    userInfo?.data?.access?.[settingsIndex]?.side_menu?.[settingsMenuIndex]
      ?.top_menu || [];

  const dynamicSettingsItems = topMenus
    .map((menuItem, index) => {
      const hasViewAccess = getSettingViewStatus(
        userInfo,
        index,
        settingsMenuIndex,
        0
      );
      if (!hasViewAccess) return null;

      const isRedirect = menuItem.app !== "CENTRAL";
      let path = menuItem.url;

      if (!isRedirect && path?.startsWith("https://testapps.trainery.one/")) {
        path = path.replace("https://testapps.trainery.one", "");
      }

      return {
        path,
        name: menuItem.name,
        redirect: isRedirect,
      };
    })
    .filter(Boolean);
  return dynamicSettingsItems;
};

export const SecondaryNavCaAdmin = () => {
  const userInfo = useSelector((state) => state.user);

  const datasend = [
    {
      path: "/ca-admin/organization/profile/dashboard",
      name: getSubMenuName(userInfo, 0, 0),
      icon: <ProjectOutlined />,
    },

    getViewStatus(userInfo, 0, 1) && {
      path: "/ca-admin/organization/profile/details",
      name: getSubMenuName(userInfo, 0, 1),
      icon: <AuditOutlined />,
    },
    getViewStatus(userInfo, 0, 2) && {
      path: "/ca-admin/organization/profile/subscription",
      name: getSubMenuName(userInfo, 0, 2),
      icon: <TagsOutlined />,
    },
    getViewStatus(userInfo, 0, 3) && {
      path: "/ca-admin/organization/profile/relationships",
      name: getSubMenuName(userInfo, 0, 3),
      icon: <ApiOutlined />,
    },
    getViewStatus(userInfo, 0, 4) && {
      path: "/ca-admin/organization/profile/structure",
      name: getSubMenuName(userInfo, 0, 4),
      icon: <PartitionOutlined />,
    },
    env !== "prod" && {
      path: "/ca-admin/organization/profile/work-roles",
      name: "Work Roles",
      icon: <ContactsOutlined />,
    },
    getViewStatus(userInfo, 0, 5) && {
      path: "/ca-admin/organization/profile/locations",
      name: getSubMenuName(userInfo, 0, 5),
      icon: <EnvironmentOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};

export const SecondaryNavAuditCA = () => {
  const userInfo = useSelector((state) => state.user);
  const datasend = [
    getViewStatus(userInfo, 2, 0) && {
      path: "/ca-admin/organization/audit-trail/login",
      name: getSubMenuName(userInfo, 2, 0),
      icon: <LoginOutlined />,
    },
    getViewStatus(userInfo, 2, 1) && {
      path: "/ca-admin/organization/audit-trail/email",
      name: getSubMenuName(userInfo, 2, 1),
      icon: <FileOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const SecondaryNavSettingsCA = () => {
  const userInfo = useSelector((state) => state.user);
  const datasend = [
    getViewStatus(userInfo, 1, 0) && {
      path: "/ca-admin/organization/settings/logo",
      name: getSubMenuName(userInfo, 1, 0),
      icon: <CloudUploadOutlined />,
    },
    getViewStatus(userInfo, 1, 1) && {
      path: "/ca-admin/organization/settings/login-settings",
      name: getSubMenuName(userInfo, 1, 1),
      icon: <CloudSyncOutlined />,
    },
    getViewStatus(userInfo, 1, 2) && {
      path: LMS_REDIRECT_NOTIFICATION,
      name: getSubMenuName(userInfo, 1, 2),
      icon: <img src={Notification} alt="" height={15} width={15} />,
      redirect: true,
    },
    getViewStatus(userInfo, 1, 3) && {
      path: LMS_REDIRECT_STRUCTURE,
      name: getSubMenuName(userInfo, 1, 3),
      icon: <img src={Structure} alt="" height={15} width={15} />,
      redirect: true,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};

export const SecondaryNavCommunications = () => {
  const userInfo = useSelector((state) => state.user);
  const datasend = [
    (env === "dev" || env === "local") && {
      path: "/ca-admin/organization/communications/notifications/",
      name: "NOTIFICATION SUMMARY",
      icon: <BellOutlined />,
    },
    getViewStatus(userInfo, 3, 0) && {
      path: "/ca-admin/organization/communications/templates",
      name: getSubMenuName(userInfo, 3, 0),
      icon: <MailOutlined />,
    },
    getViewStatus(userInfo, 3, 1) && {
      path: "/ca-admin/organization/communications/triggers",
      name: getSubMenuName(userInfo, 3, 1),
      icon: <SendOutlined />,
    },
    getViewStatus(userInfo, 3, 2) && {
      path: "/ca-admin/organization/communications/logs",
      name: getSubMenuName(userInfo, 3, 2),
      icon: <FieldTimeOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
//****************************************Tn admin Course Routes********************************** */

export const CourseTopLevel = () => {
  const datasend = [
    false && {
      path: REDIRECT_DASHBOARD_TRAINERY_LEARN,
      name: "Dashboard",
      redirect: true,
    },
    {
      path: "/trainery-learn/courses",
      name: "Courses",
    },
    {
      path: "/trainery-learn/quiz",
      name: "Quiz",
    },
    {
      path: "/trainery-learn/topics",
      name: "Topics",
    },
    {
      path: "/trainery-learn/producers",
      name: "Producers",
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};
export const SecondaryNavTraineryLearn = () => {
  const datasend = [
    {
      path: "/trainery-learn/courses/listing",
      name: "All Courses",
      icon: <ContainerOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const TraineryLearnAdd = () => {
  const datasend = [
    {
      path: "/trainery-learn/courses/add",
      name: "Add Course",
      icon: <FileAddTwoTone />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const CatAndSubCatNavTN = () => {
  const datasend = [
    {
      path: "/trainery-learn/topics/categories",
      name: "Category And Sub-Categories",
      icon: <GroupOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const TraineryLearnEdit = (id) => {
  const datasend = [
    {
      path: `/trainery-learn/courses/edit/${id}`,
      name: "Edit Course",
      icon: <EditTwoTone />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
//****************************************CA admin Course Routes********************************** */

export const CourseTopLevelCA = () => {
  const datasend = [
    {
      path: "/ca-admin/trainery-learn/courses",
      name: "Courses",
    },
    {
      path: "/ca-admin/trainery-learn/bundles",
      name: "Bundles",
    },
    {
      path: "/ca-admin/trainery-learn/learning-path",
      name: "Learning Path",
    },
    {
      path: "/ca-admin/trainery-learn/topics",
      name: "Topics",
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};
export const RecordsTopLevelCA = () => {
  const datasend = [
    {
      path: "/ca-admin/trainery-learn/records",
      name: "Learning Management",
    },
    {
      path: "/ca-admin/trainery-learn/learning-matrix",
      name: "Learning Matrix",
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};
export const SecondaryNavTraineryLearnCA = () => {
  const datasend = [
    {
      path: "/ca-admin/trainery-learn/courses/listing",
      name: "All Courses",
      icon: <ContainerOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const TraineryLearnCaAdd = () => {
  const datasend = [
    {
      path: "/ca-admin/trainery-learn/courses/add",
      name: "Add Course",
      icon: <FileAddTwoTone />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const TraineryLearnCaEdit = (id) => {
  const datasend = [
    {
      path: `/ca-admin/trainery-learn/courses/edit/${id}`,
      name: "Edit Course",
      icon: <EditTwoTone />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const CatAndSubCatNav = () => {
  const datasend = [
    {
      path: "/ca-admin/trainery-learn/topics/categories",
      name: "Category And Sub-Categories",
      icon: <GroupOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const LearningMatrixNav = () => {
  const datasend = [
    {
      path: "/ca-admin/trainery-learn/learning-matrix/work-roles",
      name: "Work Role Matrix",
      icon: <BorderlessTableOutlined />,
    },
    {
      path: "/ca-admin/trainery-learn/learning-matrix/course-roles",
      name: "Course Matrix",
      icon: <ApartmentOutlined />,
    },
    {
      path: "/ca-admin/trainery-learn/learning-matrix/learner-roles",
      name: "Learner Matrix",
      icon: <InsertRowAboveOutlined />,
    },
    {
      path: "/ca-admin/trainery-learn/learning-matrix/course-learners",
      name: "Learner Course Matrix",
      icon: <BuildOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const LearningRecordsNav = () => {
  const datasend = [
    {
      path: "/ca-admin/trainery-learn/records/listing",
      name: "Records Summary",
      icon: <FileProtectOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const LearningRecordsAddNav = () => {
  const datasend = [
    {
      path: "/ca-admin/trainery-learn/records/add",
      name: "Add Record",
      icon: <FileAddTwoTone />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
export const LearningRecordsEditNav = () => {
  const datasend = [
    {
      path: "/ca-admin/trainery-learn/records/edit",
      name: "Edit Record",
      icon: <EditTwoTone />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};
//****************************************User Routes********************************** */

export const UserTopLevel = () => {
  const datasend = [
    {
      path: REDIRECT_PROFILE,
      name: "My Portal (Beta)",
      redirect: true,
    },
    {
      path: "/user/communications",
      name: "Notifications",
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};
export const SecondaryNavUser = () => {
  const datasend = [
    {
      path: "/user/communications/notifications/",
      name: "NOTIFICATION SUMMARY",
      icon: <BellOutlined />,
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);
  return filteredDatasend;
};

//****************************************admin module edit********************************** */

export const TLModuleEdit = [
  {
    path: "/admin-manager/modules/access/1/tl-dashboard-edit",
    name: "Trak Learning",
    icon: <DashboardOutlined />,
  },
  {
    path: "/admin-manager/modules/access/1/tl-creds-edit",
    name: "Trak Credentials",
    icon: <ProfileOutlined />,
  },
  {
    path: "/admin-manager/modules/access/1/tl-events-edit",
    name: "Trak Events",
    icon: <PicRightOutlined />,
  },
];

export const TCModuleEdit = [
  {
    path: "/admin-manager/modules/access/2/tc-dashboard-edit",
    name: "Trak Coaching",
    icon: <DashboardOutlined />,
  },
  {
    path: "/admin-manager/modules/access/2/tc-creds-edit",
    name: "Trak Credentials",
    icon: <PicRightOutlined />,
  },
  {
    path: "/admin-manager/modules/access/2/tc-engagements-edit",
    name: "Engagements",
    icon: <ProfileOutlined />,
  },
];

export const DHRModuleEdit = [
  {
    path: "/admin-manager/modules/access/3/dhr-knowledge-edit",
    name: "Knowledge Center",
    icon: <DashboardOutlined />,
  },
  {
    path: "/admin-manager/modules/access/3/dhr-docustar-edit",
    name: "Docustar",
    icon: <PicRightOutlined />,
  },
];
//****************************************CA Customer Routes********************************** */

export const CustomerTopLevel = () => {
  const datasend = [
    {
      path: "/ca-admin/customers",
      name: "Customers",
    },
  ];
  const filteredDatasend = datasend.filter((item) => item !== false);

  return filteredDatasend;
};
/************************************* less used routes ******************************* */

export const TRAKLearningMenu = [
  {
    path: "/admin-access.trak-learning/clients",
    name: "CLIENTS",
  },
  // {
  //   path: "/admin-access.settings/naics",
  //   name: "NAICS CODES",
  // },
];
export const TRAKCoachingMenu = [
  {
    path: "/admin-access.trak-coaching/clients",
    name: "CLIENTS",
  },
  // {
  //   path: "/admin-access.settings/naics",
  //   name: "NAICS CODES",
  // },
];
export const DelegateHRMenu = [
  {
    path: "/admin-access.delegatehr/clients",
    name: "CLIENTS",
  },
  // {
  //   path: "/admin-access.settings/naics",
  //   name: "NAICS CODES",
  // },
];
